import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import get from 'lodash/get';


import fetchQuery from 'rebook/apps/utils/fetchQuery';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import { URLS } from 'rebook/apps/base/constants';
import pluralize from 'rebook/apps/utils/text/pluralize';


import styles from './style.scss';


class UserBookmarkView extends React.Component {
  constructor(props) {
    super(props);
    this.paginateBy = 24;

    this.state = {
      dataList: [],
      pageNumber: 1,
      lastPageNumber: 1,
      totalDataCount: 0,
    };
  }

  componentDidMount() {
    this.changePage(1);
  }

  changePage(pageNumber = 1) {
    const userId = parseInt(this.props.match.params.userId, 10);
    const offset = (pageNumber - 1) * this.paginateBy;
    const url = `/api/profile/${userId}/followed-authors/?limit=${this.paginateBy}&offset=${offset}`;
    fetchQuery(url, { apiVersion: 3 })
      .then(
        ({ data }) => {
          const lastPageNumber = Math.ceil(data.meta.total_count / this.paginateBy);
          this.setState({
            totalDataCount: data.meta.total_count,
            dataList: data.objects,
            pageNumber: pageNumber,
            lastPageNumber: lastPageNumber,
          });
        },
      );
  }

  render() {
    const { user } = this.props;
    const { dataList, totalDataCount } = this.state;
    const userId = parseInt(this.props.match.params.userId, 10);

    if (!user || userId !== user.id) {
      return <Redirect to={URLS.dashboard} />;
    }
    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Мои книги', url: `/profile/${this.props.match.params.userId}/` },
            { text: 'Избранное', url: get(this, 'props.location', '') },
          ]} />
        </div>
        <div className={styles.container}>
          <div className="title-1">Избранное</div>
          <div
            className={styles.counter}>{totalDataCount} {pluralize(totalDataCount, 'автор', 'автора', 'авторов')}
          </div>
          {dataList &&
          <div className={styles.itemsList}>
            {dataList.length > 0 && dataList.map((item) => (
              <div className={styles.item} key={item.id}>
                <Link to={item.absolute_url}>
                  <div className={styles.itemImage}>
                    <CroppedImage className={styles.itemImageCover}
                      height="48"
                      width="48"
                      src={item.photo} />
                  </div>
                </Link>
                <div className={styles.itemText}>
                  <Link to={item.absolute_url}>
                    <div className={styles.itemHeader}>{item.cover_name}</div>
                  </Link>
                  <div className={styles.itemCounter}>{item.active_book_count} книг</div>
                </div>
              </div>
            ))}
            <ContextPagination
              extraClassName={classNames('jest-bookshelf-list-pagination', styles.itemPagination)}
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={this.state.pageNumber}
              lastPage={this.state.lastPageNumber} />
          </div>
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(UserBookmarkView);
